var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserProfileMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.318 26.05a1.19 1.19 0 0 0 1.186-1.186c0-5.676-4.601-10.278-10.277-10.278C5.552 14.586.95 19.188.95 24.864a1.19 1.19 0 0 0 1.186 1.186 1.19 1.19 0 0 0 1.187-1.186 7.906 7.906 0 0 1 7.904-7.905 7.906 7.906 0 0 1 7.905 7.905 1.19 1.19 0 0 0 1.186 1.186ZM4.928 7.25c0 3.482 2.817 6.3 6.3 6.3 3.481 0 6.3-2.818 6.3-6.3 0-3.482-2.819-6.3-6.3-6.3a6.296 6.296 0 0 0-6.3 6.3Zm10.227 0a3.924 3.924 0 0 1-3.928 3.927A3.924 3.924 0 0 1 7.3 7.25a3.924 3.924 0 0 1 3.927-3.927 3.924 3.924 0 0 1 3.928 3.927Z",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfileMenu);
export default __webpack_public_path__ + "static/media/icon_user_profile_menu.7671193e.svg";
export { ForwardRef as ReactComponent };